export default __webpack_public_path__ + "static/media/scrn-1.6daecd24.png";